import { NgModule } from '@angular/core';
import { UpgradePlanDialogComponent } from './upgrade-plan-dialog.component';
import { IconsModule } from '../../../icons/icons.module';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedModule } from '../../../shared/shared.module';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    UpgradePlanDialogComponent
  ],
  imports: [
    IconsModule,
    MatDialogModule,
    SharedModule,
    MatCardModule,
    MatDividerModule,
    CommonModule
  ]
})
export class UpgradePlanDialogModule { }
